import { fetchInstances } from './actions/instances';
import { fetchComments } from './actions/comments';
import { fetchLikes } from './actions/likes';
import { fetchSnippets } from './actions/snippets';
import { fetchStats } from './actions/stats';

export function loadData(store) {
	var state = store.getState();

	if (state.comments.length === 0 && state.features.comments === true) {
		setTimeout(store.dispatch.bind(store, fetchComments()), 10);
	}
	if (state.features.switch_instance === true && state.instances.data.length === 0) {
		setTimeout(store.dispatch.bind(store, fetchInstances()), 10);
	}
	if (!state.likes.loaded) {
		setTimeout(store.dispatch.bind(store, fetchLikes()), 10);
	}
	if (state.snippets.length === 0) {
		setTimeout(store.dispatch.bind(store, fetchSnippets()), 10);
	}
	if (state.ui.show_views === true && (state.stats === undefined || state.stats.views === undefined)) {
		setTimeout(store.dispatch.bind(store, fetchStats()), 10);
	}
}

export function padNumber(num, width) {
	num = num.toString();

	return num.length >= width ? num : (new Array(width - num.length + 1)).join(0) + num;
};

export function formatTimestamp(timestamp) {
	return Math.floor(timestamp / 3600).toString() + ":" + padNumber(Math.floor(timestamp / 60), 2).toString() + ":" + padNumber(Math.floor(timestamp % 60), 2)
};

export function parseTimestamp(timestamp_text, duration) {
	var i = 0, scale = 1, parts = timestamp_text.split(":"), timestamp = 0;

	if (timestamp_text.search(/^\d+:([0-5]\d|\d):([0-5]\d|\d)$/) === -1) {
		throw new Error("Timestamp must be a valid time in the format 00:00:00");
	}

	for (i=parts.length-1; i>=0; i--) {
		timestamp += parseInt(parts[i], 10) * scale;
		scale *= 60;
	}

	if (duration > 0 && timestamp > duration) {
		throw new Error("Timestamp is past the end of the video");
	}

	return timestamp;
};

export function formatDate(d) {
	if (typeof(d) === "number") {
		d = new Date(d * 1000);
	}

	var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];

	return d.getDate().toString()+" "+months[d.getMonth()]+" "+d.getFullYear().toString();
};

export function formatDateTime(d) {
	if (typeof(d) === "number") {
		d = new Date(d * 1000);
	}

	var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];

	return d.getHours()+":"+padNumber(d.getMinutes(), 2)+":"+padNumber(d.getSeconds(), 2)+", "+d.getDate().toString()+" "+months[d.getMonth()]+" "+d.getFullYear().toString();
};

export function formatDateAsRFC3339(d) {
	return d.getUTCFullYear()+'-'
		+ padNumber(d.getUTCMonth()+1, 2)+'-'
		+ padNumber(d.getUTCDate(), 2)+'T'
		+ padNumber(d.getUTCHours(), 2)+':'
		+ padNumber(d.getUTCMinutes(), 2)+':'
		+ padNumber(d.getUTCSeconds(), 2)+'Z';
}

export function formatFileSize(bytes) {
	if (bytes>=1073741824)
		return (bytes/1073741824).toFixed(2)+' GB';
	else if (bytes>=1048576)
		return (bytes/1048576).toFixed(2)+' MB';
	else if (bytes>=1024)
		return (bytes/1024).toFixed(2)+' KB';
	else if (bytes>1)
		return bytes+' bytes';
	else if (bytes===1)
		return bytes+' byte';
	else
		return '0 bytes';
}

export function findIndex(arr, predicate) {
	// 1. Let O be ? ToObject(this value).
	var o = Object(arr);

	// 2. Let len be ? ToLength(? Get(O, "length")).
	var len = o.length >>> 0;

	// 3. If IsCallable(predicate) is false, throw a TypeError exception.
	if (typeof predicate !== 'function') {
		throw new TypeError('predicate must be a function');
	}

	// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
	var thisArg = arguments[1];

	// 5. Let k be 0.
	var k = 0;

	// 6. Repeat, while k < len
	while (k < len) {
		// a. Let Pk be ! ToString(k).
		// b. Let kValue be ? Get(O, Pk).
		// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
		// d. If testResult is true, return k.
		var kValue = o[k];
		if (predicate.call(thisArg, kValue, k, o)) {
			return k;
		}
		// e. Increase k by 1.
		k++;
	}

	// 7. Return -1.
	return -1;
}

export function executeElementScripts(body_el) {
	// Finds and executes scripts in a newly added element's body.
	// Needed since innerHTML does not run scripts.
	//
	// Argument body_el is an element in the dom.

	function nodeName(elem, name) {
		return elem.nodeName && elem.nodeName.toUpperCase() ===
							name.toUpperCase();
	};

	function evalScript(elem) {
		var data = (elem.text || elem.textContent || elem.innerHTML || "" ),
				head = document.getElementsByTagName("head")[0] ||
									document.documentElement,
				script = document.createElement("script");

		script.type = "text/javascript";
		try {
			// doesn't work on ie...
			script.appendChild(document.createTextNode(data));			
		} catch(e) {
			// IE has funky script nodes
			script.text = data;
		}

		head.insertBefore(script, head.firstChild);
		head.removeChild(script);
	};

	// main section of function
	var scripts = [],
			script,
			children_nodes = body_el.childNodes,
			child,
			i;

	for (i = 0; children_nodes[i]; i++) {
		child = children_nodes[i];
		if (nodeName(child, "script" ) &&
			(!child.type || child.type.toLowerCase() === "text/javascript")) {
					scripts.push(child);
			}
	}

	for (i = 0; scripts[i]; i++) {
		script = scripts[i];
		if (script.parentNode) {script.parentNode.removeChild(script);}
		evalScript(scripts[i]);
	}
};

export function logEvent(data) {
	if (window.esuConfig === undefined) {
		return
	}

	window.esuConfig.queue.push({ type: "events", data: data });
}

export const filterCommentByType = (required_comment_type)=>(
	({comment_type, parent_comment_type}, index)=>(
		required_comment_type===comment_type ||
		required_comment_type===parent_comment_type ||
		"archived_"+required_comment_type===comment_type ||
		"archived_"+required_comment_type===parent_comment_type
	)
)

export const filterOutArchivedComment = ({objectid})=>(objectid!=="n/a");

// Comment types excluded from the "All" view/count.
// To switch to "Private-only", set this to ["personal"] (and add 'feedback'
// back to the server-side getItemInteractionStatistics IN-list in tv2Gallery.cfc).
export const TYPES_EXCLUDED_FROM_ALL = ["personal", "feedback"];

// True when a comment (or, for replies, its parent) is allowed in the "All" view.
export const filterIncludedInAll = ({ comment_type, parent_comment_type }) => {
	const base = (t) => (t || "").replace(/^archived_/, "");
	return TYPES_EXCLUDED_FROM_ALL.indexOf(base(comment_type)) === -1
		&& (!parent_comment_type || TYPES_EXCLUDED_FROM_ALL.indexOf(base(parent_comment_type)) === -1);
};

export function getTypes(selected_type, comments, features) {
	var types = [
		{ id:"course", label:"Course", description:"Posting to anyone who who is enrolled in this course" },
		{ id:"public", label:"Public", description:"Posting to anyone who can see this media item in this course" },
		{ id:"personal", label:"Private", description:"Posting notes to yourself" },
		{ id:"feedback", label:"Feedback", description:"Posting to the owners of this media item" }
	].filter(({id})=>features["view_all_"+id] || features["view_created_"+id]).map(({id,label,description}, index)=>({
		id,
		label,
		description,
		count: comments.filter(filterCommentByType(id)).filter(filterOutArchivedComment).length,
		active: id===selected_type || (selected_type === "" && index === 0)
	}));

	if (types.length > 1) {
		types.unshift({
			id: "all",
			label: "All",
			description: "",
			count: comments.filter(filterOutArchivedComment).filter(filterIncludedInAll).length,
			active: selected_type==="all"
		});
	}

	return types;
}

export function getURL(download, instance) {
	if (download.link) {
		return download.link;
	}

	if (download.code === "comments") {
		return window[download.fn](instance, { bShowGeneral : true, bShowTimeline : true, bShowPersonal : true, bShowPublic : true, bShowCourse : true, bShowFeedback : true, search : "" });
	}
	else {
		return window[download.fn](instance);
	}
}
